<template>
    <div id="data-parametro-meta-view">
        <vx-card
            title=""
            title-color="#fff"
            card-background="linear-gradient(90deg, rgba(28,92,156,1) 0%, rgba(9,9,121,1) 31%, rgba(0,212,255,1) 98%)"
            content-color="#fff"
            class="mb-4">
            <div class="vx-row">
                <div class="w-full vx-col sm:w-3/4">
                    <h3 class="mt-4 text-white"><strong>RIKUQ</strong></h3>
                    <h3 class="mt-1 mb-3 text-white"><small>Plataforma de Control de Personal Técnico</small></h3>
                </div>
                <div class="w-full vx-col sm:w-1/4">
                    <div class="flex flex-col items-end justify-start text-white">
                        <img src="@/assets/images/pages/regioncusco.png" width="118" height="60" class="mt-2">
                    </div>
                </div>
            </div>

        </vx-card>
        <div class="w-full vx-col">
            <div class="flex flex-col items-center justify-center text-white">
                <img src="@/assets/images/pages/app.png" width="500" alt="login" class="mx-auto mt-base">
            </div>
        </div>
    </div>
</template>
<script>
import vSelect from 'vue-select';
import VueApexCharts from 'vue-apexcharts';
import StatisticsCardLine from '@/components/statistics-cards/StatisticsCardLine.vue';

export default {
    components: {
        'v-select': vSelect,
        VueApexCharts,
        StatisticsCardLine
    },

    data(){
        return {
            selectedProvincia: {value: '', label: 'Todos'},
            selectedDistrito: null,
            itemsProvincia: [],
            itemsDistrito: [],

            isAll: true,
            itemsAll: [],

            barChartPim: {
                series: [],
                chartOptions: {}
            },

            barChartEjec: {
                series: [],
                chartOptions: {}
            }
        }
    },

    created(){

    },

    watch: {

    },

    mounted(){

    },

    methods: {
        
        showMessageAlert(message){
            this.$vs.notify({
                title: 'Aviso',
                text: message,
                position:'top-center',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'danger'
            });
        },

        showMessageSuccess(message){
            this.$vs.notify({
                title: 'Información',
                text: message,
                position:'top-right',
                iconPack: 'feather',
                icon: 'icon-check',
                color: 'success'
            });
        },

        showMessageError(status, message){
            if(status === 400 || status === 409){
                this.$vs.notify({
                    title: 'Aviso',
                    text: message,
                    position:'top-center',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'warning'
                });
            }
            if(status === 401){
                this.$store.dispatch("logout").then(() => {
                    this.$router.push('/login').catch(() => {})
                });
            }
            if(status === 403){
                this.popupPaciente = false;
                this.popupEliminar = false;
                this.$vs.notify({
                    title: 'ACCESO DENEGADO',
                    text: 'No tiene permisos para esta proceso.',
                    position:'top-center',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            }
            if(status === 404){
                this.$vs.notify({
                    title: 'Aviso',
                    text: message,
                    position:'top-center',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'warning'
                });
            }
            if(status === 417){
                this.$vs.notify({
                    title: 'ALERTA',
                    text: message,
                    position:'top-center',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            }

            if(status === 500){
                this.$vs.notify({
                    title: 'ERROR',
                    text: 'Ups!!!. Ocurrio un error. Vuelve a intentarlo.',
                    position:'top-center',
                    iconPack: 'feather',
                    icon: 'icon-alert-triangle',
                    color: 'danger'
                });
            }
        },

    }
}
</script>
<style lang="scss">
@import "@/assets/scss/vuexy/pages/profile.scss";
</style>